<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ptit"><a id="page_36"></a>PART II: OPENING MOVES ON THE GUSTAV LINE</h2>
<div class="img_container"><a id="page_37"></a>
<img alt="images" src="images/f0036-1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 13_Part2.vue?450bb2a1